import React from 'react';
import { LegalLink, DisclaimerColumn } from './components';

export const FooterDisclaimers: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="flex flex-col gap-[40px]">
      {/* Copyright and Legal Links */}
      <div className="w-full flex flex-col md:flex-row md:justify-between items-start md:items-center gap-4 md:gap-0">
        <div className="text-[#F4F0E7] text-[15px] font-bold leading-[21px] tracking-[0.15px]">
          Copyright© {currentYear} All in One Partners, LLC d/b/a ALYZE - All Rights Reserved
        </div>
        <div className="flex items-center gap-6 md:gap-[48px]">
          <LegalLink to="/terms-of-service">Terms of service</LegalLink>
          <LegalLink to="/privacy-policy">Privacy policy</LegalLink>
        </div>
      </div>

      {/* Disclaimers */}
      <div className="flex flex-col md:flex-row md:justify-center items-start gap-[40px]">
        <DisclaimerColumn title="FDA Disclaimer" width="w-full md:flex-1">
          Statements made on this website have not been evaluated by the Food and Drug Administration. 
          Products and services offered by All in One Partners, LLC d/b/a ALYZE are not intended to 
          diagnose, treat, cure, or prevent any disease.
        </DisclaimerColumn>

        <DisclaimerColumn title="Medical Disclaimer" width="w-full md:flex-1">
          The information provided by All in One Partners, LLC d/b/a ALYZE is for educational and 
          general wellness purposes only. It is not intended as medical advice, and should not be 
          used as a substitute for professional medical evaluation, diagnosis, or treatment. Always 
          seek the advice of your physician or other qualified healthcare provider with any questions 
          you may have regarding a medical condition or before starting any new health program, 
          therapy, or supplement.
        </DisclaimerColumn>

        <DisclaimerColumn title="Liability Disclaimer" width="w-full md:flex-1">
          By using All in One Partners, LLC d/b/a ALYZE products or services, you acknowledge and 
          agree that you do so voluntarily and at your own risk. To the fullest extent permitted by 
          law, All in One Partners, LLC d/b/a ALYZE disclaims any liability for injury, loss, or 
          damages resulting from the use or misuse of its products or reliance on the information 
          provided. Individual results may vary.
        </DisclaimerColumn>
      </div>
    </div>
  );
};
